export default {"src":"/_next/static/media/card-placeholder-2.6e00a9de.svg","height":162,"width":231,"blurWidth":0,"blurHeight":0};